<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 md4>
        <v-btn class="primary" dark text @click="categoryDialog.visible = true">編輯嘉好案件類別</v-btn>
      </v-flex>
      <v-flex xs12 md4>
        <v-btn class="primary" dark text @click="projectDialog.visible = true">編輯嘉好專案</v-btn>
      </v-flex>
      <v-flex xs12 md4>
        <v-btn color="blue" dark text @click="showSearchInfoDialog()"
        >查詢進件次數</v-btn>
      </v-flex>
    </v-layout>


    <list-editor
      :column-keys="columnKeys"
      :items="items"
      :loading="loading"
      :showSearchBar="true"
      :showAddButton="true"
      :showSearchDate="true"
      :showExportButton="true"
      :isFinanceCreditList="true"
      :searchPlaceHolder="searchPlaceHolder"
      :totalItems="getTotalItems"
      :startDate="startDate"
      :endDate="endDate"
      :sourceName="sourceName"
      :getSearchKeys="searchKeys"
      :show-select="false"
      @addData="addData"
      @editData="edit"
      @saveData="save"
      @printData="otherEvent"
      @searchData="searchData"
      @changePage="changePage"
      @changeStatus="changeStatus"
      @exportData="exportData"
      @handleLoadData="handleLoadData"
    ></list-editor>

<!--    <CCHCategoryDialog :visible="categoryDialog.visible"-->
<!--                       @closeEvent="categoryDialog.visible = false">-->
<!--    </CCHCategoryDialog>-->

    <CCHProjectDialog :visible="categoryDialog.visible"
                      :category="categoryDialog.category"
                      :title="categoryDialog.title"
                      @closeEvent="categoryDialog.visible = false">

    </CCHProjectDialog>

    <CCHProjectDialog :visible="projectDialog.visible"
                      :category="projectDialog.category"
                      :title="projectDialog.title"
                      @closeEvent="projectDialog.visible = false">

    </CCHProjectDialog>

    <!--其他工具-彈窗-->
    <CCHFinanceCreditDialog
      :item="editedItem"
      :row-item="rowItemInfo"
      :visible="toolDialog.visible"
      :platform="4"
      @showEvent="toolEvent"
      @closeEvent="toolDialog.visible = false"
      @confirmEvent="toolDialog.visible = false"
    ></CCHFinanceCreditDialog>

    <!--更新案編-->
    <v-dialog
      v-model="updateDialog.visible"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-text>
          <v-text-field v-model="updateDialog.displayId" :label="`變更案件編號`"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="red" dark text @click="updateDialog.cancel">取消</v-btn>
          <v-btn class="primary" dark text @click="updateDialog.confirm">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--代辦合約書-->
    <agent-contract-view
      :agent-contract-dialog="agentContractDialog"
      @saveContract="saveContract"
    ></agent-contract-view>

    <!--案件對保資料-->
    <v-dialog
      v-model="insureDialog.visible"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title>
          <h3>案件對保資料</h3>
        </v-card-title>
        <v-card-text>
          <case-insure-view
            :item-detail="editedItem"
            :show="insureDialog.visible"
            @saveEvent="insureDialog.confirm"
            @cancelEvent="insureDialog.cancel"
          ></case-insure-view>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--案件設定-->
    <case-stetting-view v-if="editedItem"
      :item-detail="editedItem"
      :visible="settingDialog.visible"
      :show-cancel="true"
      @saveSuccessEvent="settingDialog.confirm"
      @cancelEvent="settingDialog.cancel"
    ></case-stetting-view>

    <!--修改經辦-->
    <contact-dialog
      :visible="contactDialog.visible"
      @cancelEvent="contactDialog.visible = false"
      @confirmEvent="contactDialog.confirm"
    ></contact-dialog>

    <!--動產抵押器契約書-->
    <mortgage-dialog
      v-if="mortgageDialog.visible"
      :edited-item="newMortgageItem"
      :visible="mortgageDialog.visible"
      @closeDialog="mortgageDialog.cancel"
      @save="mortgageDialog.confirm"
      @closeEvent="closeDialogView"
    >
    </mortgage-dialog>

    <!--首期繳款日-->
    <first-date-dialog :visible="firstDateDialog.visible"
                       @cancelEvent="firstDateDialog.visible = false"
                       @confirmEvent="firstDateDialog.confirm">
    </first-date-dialog>

    <!--繳款記錄-->
    <MarketPaymentListDialog v-if="marketPaymentDialog.item && marketPaymentDialog.visible === true"
                             :visible="marketPaymentDialog.visible"
                             :item="marketPaymentDialog.item"
                             :order-id="marketPaymentDialog.orderId"
                             @cancelEvent="marketPaymentDialog.visible = false"
                             @confirmEvent="marketPaymentDialog.visible = false">
    </MarketPaymentListDialog>

    <AppropriationDialog :visible="appropriationDialog.visible"
                         :item-detail="appropriationDialog.item"
                         @cancelEvent="appropriationDialog.visible = false"
                         @confirmEvent="appropriationDialog.visible = false"></AppropriationDialog>

    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.text"
                :isHtmlContent="true"
                :showCancel="messageDialog.showCancelButton"
                @cancelEvent="messageDialog.cancel"
                @confirmEvent="messageDialog.confirm"></alert-view>

    <SearchInfoDialog :visible="searchInfoDialog.visible"
                      @cancelEvent="searchInfoDialog.cancel">
    </SearchInfoDialog>
  </v-container>
</template>

<script>
import common from '@/mixins/common';
import ListEditor from "../../components/ListEditor";
import CCHFinanceCreditDialog from "../../components/CCHFinanceCreditDialog";
import CaseInsureView from '../../components/CaseInsureView';
import AgentContractView from '../../components/AgentContractView';
import CaseStettingView from '../../components/CaseStettingView';
import ContactDialog from '../../components/ContactDialog';
import MortgageDialog from "../../components/MortgageDialog";
import { mapActions, mapGetters } from 'vuex';
import { exportFileToBlobUrl, getNow, getUUId } from '@/pages/utils/tool';
import FirstDateDialog from '@/components/FirstDateDialog';
import MarketPaymentListDialog from '@/components/MarketPaymentListDialog';
import CCHCategoryDialog from '@/components/CCHCategoryDialog';
import CCHProjectDialog from '@/components/CCHProjectDialog';
import AppropriationDialog from '@/components/AppropriationDialog';
import AlertView from '@/components/AlertView';
import SearchInfoDialog from '@/components/SearchInfoDialog';
export default {
  name: 'CCHFinanceList',
  components: {
    AlertView,
    CCHCategoryDialog,
    MarketPaymentListDialog,
    FirstDateDialog,
    ListEditor,
    CCHFinanceCreditDialog,
    CaseInsureView,
    AgentContractView,
    CaseStettingView,
    ContactDialog,
    MortgageDialog,
    CCHProjectDialog,
    AppropriationDialog,
    SearchInfoDialog
  },
  data(){
    return {
      sourceName: 'CCHFinanceList',
      items: [],
      searchPlaceHolder: "搜尋身分證、姓名、申辦人員",
      pageIndex: 1,
      limit: 25,
      totalItems: 0,
      startDate: "",
      endDate: "",
      searchKey: "",
      searchValue: "",
      loading: false,
      rowItemInfo: null,
      editedItem: null,
      newMortgageItem: null,
      categoryDialog: {
        category: 'category',
        title:'嘉好案件類別編輯',
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      projectDialog: {
        category: 'project',
        title:'嘉好專案編輯',
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      appropriationDialog: {
        visible: false,
        item: null,
        confirm: () => {},
        cancel: () => {},
      },
      toolDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      marketPaymentDialog: {
        title: "",
        text: "",
        visible: false,
        orderId: '',
        item: null,
        confirm: () => {},
        cancel: () => {},
      },
      firstDateDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      updateDialog: {
        title: "",
        text: "",
        caseId: "",
        displayId: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      changeCaseNoDialog: {
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      mortgageDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      agentContractDialog: {
        title: "",
        text: "",
        caseId: "",
        vendorName: "",
        memberName: "",
        memberId: "",
        bonus: 5,
        auto: false,
        showAuto: true,
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      insureDialog: {
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      settingDialog: {
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      contactDialog: {
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: true,
        confirm: () => {},
        cancel: () => {},
      },
      syncToken: '',
      searchInfoDialog: {
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
    };
  },
  created() {
    this.init();
    this.setDefaultDate();
    this.loadData();

    this.fetchAgentList().then(() => {
    });
  },
  mixins: [common],
  computed: {
    ...mapGetters(["getUserInfo", 'getAgentList']),
    columnKeys() {
      let list = [
        {
          value: "tools",
          text: "編輯",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
        {
          value: "print",
          text: "其他工具",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
        // {
        //   value: "notify",
        //   text: "已讀",
        //   sortable: false,
        //   required: false,
        //   isShow: true,
        //   isEdit: false,
        // },
        {
          value: "displayId",
          text: "案件編號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "name",
          text: "申辦人",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "memberId",
          text: "身分證字號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "vendorName",
          text: "經辦人",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "applyDisplayDate",
          text: "申請日期",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "latePaymentCount",
          text: "是否遲繳",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "caseStatus",
          text: "案件狀態",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "tag",
          text: "專案類型",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "project",
          text: "專案名稱",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "caseType",
          text: "顧客評分",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "creditPrice",
          text: "貸款金額",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "installmentsNumber",
          text: "總期數",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "creditPriceMonth",
          text: "月付金額",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "createDate",
          text: "建立時間",
          sortable: true,
          required: false,
          disabled: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "saveDate",
          text: "儲存日期",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "bonus",
          text: "佣金",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true,
        },
        {
          value: "settingPrice",
          text: "設定費",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true,
        },
        {
          value: "comment",
          text: "備註",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true,
        },
        // {
        //   value: "delete",
        //   text: "刪除",
        //   sortable: false,
        //   required: false,
        //   isShow: true,
        //   isEdit: false,
        // },
        {
          value: "edit",
          text: "編輯",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
      ];
      if (this.isAdmin) {
        return list;
      }
      return list.filter(
        (m) => m.value !== "changeCase" && m.value !== "delete" && m.value !== "bonus"
      );
    },
    getTotalItems() {
      return this.totalItems;
    },
    searchKeys() {
      return [
        { key: "name", value: "姓名" },
        { key: "memberId", value: "身分證字號" },
        { key: "vendorName", value: "經辦人姓名" },
        { key: "displayId", value: "案件編號" },
      ];
    },
  },
  methods: {
    ...mapActions([
      'getCCHFinanceList',
      'fetchCreditProductInfo',
      'updateCaseId',
      'syncCreditProductStatus',
      'loginAgentService',
      'saveContactInfo',
      'fetchAgentList',
      'saveExportLog'
      ]),
    showSearchInfoDialog(){
      this.searchInfoDialog.visible = true;
      this.searchInfoDialog.cancel = ()=>{
        this.searchInfoDialog.visible = false;
      }
    },
    async init(){
      this.loading = true;
      const loginResult = await this.loginAgentService({
        email: this.getUserInfo.email,
      });
      this.syncToken = loginResult.data.data.token;
    },
    setDefaultDate() {
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 36);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    async loadData(){
      let query = [];
      if (this.searchKey !== '' && this.searchValue !==''){
        query = [{ key: this.searchKey, value: this.searchValue}];
      }
      this.loading = true;
      const results = await this.getCCHFinanceList({
        token: this.syncToken,
        agentId: this.isAdmin ? "" : this.getUserInfo.agentId,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        startDate: `${this.startDate} 00:00:00`,
        endDate: `${this.endDate} 23:59:59`,
        pageIndex: this.pageIndex,
        limit: this.limit,
        searchQuery: query
      });
      this.items = results.data.data.list;
      this.totalItems = results.data.data.header.totalCount;
      this.loading = false;
      console.log(`items === ${JSON.stringify(this.items)}`);
    },
    changePage(page) {
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData();
    },
    addData() {
      this.$router.push({ path: '/home/EditCreditProduct', query: {
          caseCategory:3,
          editIndex: -1,
          agentId: this.getUserInfo.agentId,
          platform: 4
        }});
    },
    edit(item){
      this.gotoCredit(item, item.category);
    },
    gotoCredit(item, category) {
      this.editedIndex = 0;
      if(category === 2 && !item.platform) {
        item.platform = 0
      }
      const query = {
        caseCategory: category,
        editIndex: 0,
        caseId: item.caseId,
        enable: true,
        agentId: item.agentId,
        platform: item.platform ,//0裕富 3高踞
        isFinance: 1,
      };
      console.log(` gotoCredit === ${JSON.stringify(query)}`)
      // this.$router.push({ path: '/EditCreditProduct', query });
      let routeData = this.$router.resolve({
        path: "/EditCreditProduct",
        query: query,
      });
      window.open(routeData.href, "_blank");
    },
    save(){

    },
    async otherEvent(item){
      this.rowItemInfo = item;
      const results = await this.fetchCreditProductInfo({
        caseId: item.caseId,
      });
      if (results && results.length > 0) {
        this.editedItem = results[0];
        if(!this.editedItem.platform) {
          this.editedItem.platform = 0
        }
        if(this.rowItemInfo.displayId && !this.editedItem.displayId) {
          this.editedItem.displayId =  this.rowItemInfo.displayId
        }
        console.log(`this.editedItem  === ${JSON.stringify(this.editedItem)}`);
        this.toolDialog.visible = true;
      }
    },
    async toolEvent(option) {
      const index = option.key;
      console.log(`toolEvent === ${JSON.stringify(option)}`);
      if (index === 5) {
        this.showFinanceOfficialView = false;
        this.toolDialog.visible = false;
        this.agentContractDialog.visible = false;

        this.newMortgageItem = {
          profileId: Math.uuidFast(),
          parentAgent: this.editedItem.parentAgent,
          parentAgentName: this.editedItem.parentAgent.displayName,
          publishDate: "",
          name: this.editedItem.customer.name,
          memberId: this.editedItem.customer.memberId,
          engineId: "",
          startDate: {
            year: "",
            month: "",
            day: "",
            disabled: false,
            isRepublic: true,
          },
          endDate: {
            year: "",
            month: "",
            day: "",
            disabled: false,
            isRepublic: true,
          },
          creditPrice: this.editedItem.vendor.totalCreditPrice,
          createDate: getNow(),
          comment: "",
          city: "",
          area: "",
          address: this.editedItem.customer.home.residenceAddress,
          carYear: "",
          carType: "",
          carId: "",
          carEngineType: "",
          birthday: {
            year: this.editedItem.customer.birthdayInfo.year,
            month: this.editedItem.customer.birthdayInfo.month,
            day: this.editedItem.customer.birthdayInfo.day,
            disabled: false,
            isRepublic: true,
          },
          station: "",
        };
        console.log(
          `showMortgageDialog ${JSON.stringify(this.newMortgageItem)}`
        );
        this.mortgageDialog.visible = true;
        this.mortgageDialog.confirm = () => {
          this.mortgageDialog.visible = false;
          this.showMessageDialog(
            "儲存成功",
            "動產抵押契約書儲存成功",
            true,
            () => {},
            () => {}
          );
        };
        this.mortgageDialog.cancel = () => {
          this.mortgageDialog.visible = false;
        };
      } else if (index === 6) {
        this.mortgageDialog.visible = false;
        this.showFinanceOfficialView = false;
        this.toolDialog.visible = false;
        this.agentContractDialog.visible = true;
        this.agentContractDialog.caseId = this.editedItem.caseId;
        this.agentContractDialog.memberId = this.editedItem.customer.memberId;
        this.agentContractDialog.memberName = this.editedItem.customer.name;
        this.agentContractDialog.cancel = () => {
          this.agentContractDialog.visible = false;
        };
      } else if (index === 7) {
        this.showFinanceOfficialView = false;
        this.toolDialog.visible = false;
        // this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
        this.updateDialog.visible = true;
        this.updateDialog.confirm = async () => {
          this.updateDialog.visible = false;

          if (this.updateDialog.displayId === "") {
            return;
          }

          await this.updateCaseId({
            caseId: this.editedItem.caseId,
            displayId: this.updateDialog.displayId,
          });

          this.showMessageDialog(
            "儲存成功",
            "更新案編儲存成功",
            true,
            () => {},
            () => {}
          );
        };
        this.updateDialog.cancel = () => {
          this.updateDialog.visible = false;
        };
      } else if (index === 8) {
       //對保資料
       this.toolDialog.visible = false;
       this.insureDialog.visible = true;
       this.insureDialog.confirm = () => {
         this.insureDialog.visible = false;
         this.loadData();
       };
       this.insureDialog.cancel = () => {
         this.insureDialog.visible = false;
       };
     } else if (index === 9) {
       //設定資料
       this.toolDialog.visible = false;
       this.settingDialog.visible = true;
       console.log(`settingDialog === ${this.settingDialog.visible}`);
       this.settingDialog.confirm = () => {
         this.settingDialog.visible = false;
         this.loadData();
       };
       this.settingDialog.cancel = () => {
         this.settingDialog.visible = false;
       };
      } else if (index === 10) {
        this.contactDialog.visible = true;

        this.contactDialog.confirm = (selectAgentId) => {
          const find = this.getAgentList.find(
            (agent) => agent.agentId === selectAgentId
          );
          if (find) {
            const postData = {
              caseId: this.editedItem.caseId,
              agentId: find.agentId,
              contactPhone: find.cellphone,
              contactName: find.displayName,
            };
            this.changeContact(postData);
          }
          this.contactDialog.visible = false;
          this.toolDialog.visible = false;
        };
      } else if (index === 31) { // 建立繳款單

        console.log(`firstDateDialog == ${this.firstDateDialog.visible}`);
        this.firstDateDialog.visible = true;
        const self = this;
        this.firstDateDialog.confirm = async (firstPaymentDate)=> {
          let order = {
            orderId: getUUId(),
            name: this.rowItemInfo.name,
            productName: this.rowItemInfo.productName,
            memberId: this.rowItemInfo.memberId,
            cellphone: this.rowItemInfo.cellphone,
            total: this.rowItemInfo.creditPriceMonth,
            period: this.rowItemInfo.installmentsNumber,
            comment: this.rowItemInfo.comment,
            displayId: this.rowItemInfo.displayId,
            paymentList: [],
          };
          const result = await this.createMarketPaymentInfo(firstPaymentDate, order);
          console.log(`createMarketPaymentInfo == ${JSON.stringify(result)}`);
          if (result.statusCode === 0) {
            const url = `https://cchpay.haorich.tw/MarketPaymentView?orderId=${order.orderId}`;
            self.showMessageDialog(`提示`, `超商繳款單已產生，請複製繳款連結！\n${url}`, true, () => {},
              () => {});
          } else {
            self.showMessageDialog(`錯誤`, result.message, true, () => {},() => {});
          }
        }
      } else if (index === 32) { // 繳款紀錄
        if (this.rowItemInfo.displayId && this.rowItemInfo.displayId !==''){
          this.marketPaymentDialog.orderId = this.rowItemInfo.displayId;
        } else {
          this.marketPaymentDialog.orderId = this.rowItemInfo.memberId;
        }

        this.marketPaymentDialog.visible = true;
        this.marketPaymentDialog.item = this.rowItemInfo;
      } else if (index === 33) { // 撥款資料
        this.toolDialog.visible = false;
        this.appropriationDialog.visible = true;
        this.appropriationDialog.item = this.rowItemInfo;
        console.log(`show appropriationDialog = ${this.appropriationDialog.visible}`);
      } else if (index === 34) { // 撥款資料
        const rowItem = option.info;
        const url = `https://cchpay.haorich.tw/MarketPaymentView?orderId=${rowItem.displayId}`;
        window.open(url, '_blank');
      }
    },
    async changeContact(data) {
      const result = await this.saveContactInfo(data);
      this.toolDialog.visible = false;
      this.loadData();
    },
    searchData(searchInfo) {
      console.log(`searchData == ${JSON.stringify(searchInfo)}`);
      this.searchKey = searchInfo.searchKey;
      this.startDate = searchInfo.startDate;
      this.endDate = searchInfo.endDate;
      this.searchValue = searchInfo.keyword;
      if (searchInfo.searchKey === ''){
        this.setDefaultDate();
      }
      this.loadData();
    },
    handleLoadData() {
      this.loadData()
    },
    changeStatus(item) {
      this.showMessageDialog(
        "提示",
        "確認要更改狀態嗎？",
        true,
        async () => {
          console.log("確認更改狀態");

          const change = {
            token: this.syncToken,
            caseId: item.caseId,
            caseStatus: item.caseStatus,
          };
          await this.syncCreditProductStatus(change);
          this.loadData();
        },
        () => {
          console.log("取消更改狀態");
          this.loadData();
        }
      );
    },
    async exportData() {
      this.loading = true;

      const query = {
        token: this.syncToken,
        agentId: this.isAdmin ? "" : this.getUserInfo.agentId,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        startDate: this.startDate,
        endDate: this.endDate,
        pageIndex: 1,
        limit: 10000,
      };
      this.saveExportLog({
        searchContent: JSON.stringify(query),
        agentId: this.getUserInfo.agentId,
        email: this.getUserInfo.email,
        displayName: this.getUserInfo.displayName,
      });

      if (this.getUserInfo.enableExport === true || this.isAdmin || this.isManager){
        const results = await this.getCCHFinanceList(query);
        let columns = [];
        const list = this.columnKeys.filter((m) => m.isEdit);
        list.forEach((info) => {
          const itemInfo = {
            name: info.text,
            key: info.value,
          };
          columns.push(itemInfo);
        });
        columns.push({
          name: '撥佣對象',
          key: 'commissionTarget',
        });
        const resultList = results.data.data.list;
        for (let i in resultList) {
          let resultItemInfo = resultList[i]
          if (resultItemInfo.category === 2 && resultItemInfo.productId === "0") {
            resultItemInfo.productName = "商品貸原融";
          }
        }
        exportFileToBlobUrl("嘉好案件匯出", columns, resultList);
        this.loading = false;
      }

    },
    saveContract(data) {
      console.log(`save contract == ${JSON.stringify(data)}`);
      let routeData = this.$router.resolve({
        path: "/AgentContract",
        query: {
          contractId: this.agentContractDialog.caseId,
        },
      });
      window.open(routeData.href, "_blank");
      this.agentContractDialog.visible = false;
    },
    closeDialogView() {
      this.mortgageDialog.visible = false;
      this.agentContractDialog.visible = false;
      this.settingDialog.visible = false;
      this.insureDialog.visible = false;
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/CCHFinanceList.vue